import * as React from 'react';
import Box from '@mui/material/Box';
import { Button, Divider, Grid, Stack } from '@mui/material';
import axios from 'axios';
import CustomSnackbar from '../../../../../../Components/Snackbar/Snackbar';
import CustomBackdrop from '../../../../../../Components/CustomBackdrop/Barckdrop';
import { genpostURL, genpostURLTEST, genURL } from '../../../../../../_getjson';
import CustomDataGrid from '../../../../../../Components/CustomDataGrid/CustomDataGrid';
import GroupAddRoundedIcon from '@mui/icons-material/GroupAddRounded';
import FullScreenDialog from '../../../../../../Components/CustomDialogs/Fullscreendialog';
import Reportpremissionnanage from '../addpermision/addpermision';
import Confirmdialog from '../../../../../../Components/CustomDialogs/Confirmdialog';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import UseAutocomplete from '../../../../../../Components/CustomInput/UseAutocompletes';
const columns = [
    { field: 'id', headerName: 'id', width: 0, hide: true },
    {
        field: 'code',
        headerName: 'รหัสรายงาน',
        width: 100,
        editable: false,

    },
    {
        field: 'nameth',
        headerName: 'ชื่อรายงาน',
        width: 500,
        editable: false,
        flex: 1
    },
    {
        field: 'nameen',
        headerName: 'ชื่อรายงาน(EN)',
        width: 500,
        editable: false,
        flex: 1
    }
];
const styleMenu = {
    color: "black",
    cursor: "pointer",
    fontFamily: "Customfont !important",
    borderColor: "#bcbcbc",
    backgroundColor: "#bcbcbc",

}
export default function Listpermision() {
    const [value, setValue] = React.useState('1');
    const [mainData, setmainData] = React.useState([]);
    const [reportData, setreportData] = React.useState([]);
    const [permisionData, setpermisionData] = React.useState([]);
    const [disabledb_save, setdisabledb_save] = React.useState(true);
    const [rows, setRows] = React.useState([])
    const [rowsall, setRowsall] = React.useState([])
    //----------------------------alert ----------------------------
    const [color, setColor] = React.useState("")
    const [opensnackbar, setOpensnackbar] = React.useState(false)
    const [autoClose, setAutoClose] = React.useState(3600)
    const [messagealert, setMessagealert] = React.useState("")
    const [icon, setIcon] = React.useState("")
    //------------------------fulldialog------------------------------ 
    const [openFullScreenDialog, setopenFullScreenDialog] = React.useState(false)
    const [titleFullScreenDialog, settitleFullScreenDialog] = React.useState("เพิ่มสิทธิ์รายงาน")
    const [openbackdrop, setopenbackdrop] = React.useState(false)
    const [percentCompleted, setpercentCompleted] = React.useState(0)
    const [dataFordel, setdataFordel] = React.useState([])
    //------------------------------- Confirmdialog -------------------------------
    const [Agreetxt, setAgreetxt] = React.useState('ใช่')
    const [description, setdescription] = React.useState('')
    const [openconfirmdialog, setopenconfirmdialog] = React.useState(false)
    //--------------------
    const [reloaddatas, setreloaddatas] = React.useState(false)
    const [choiceval, setChoiceval] = React.useState(localStorage.getItem("Permissiongroup"))
    const [choiceData, setChoiceData] = React.useState([])
    const options = {
        onUploadProgress: (progressEvent) => {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            console.log(percentCompleted);
            setpercentCompleted(percentCompleted)
        },
    };
    React.useEffect(() => {
        checkData()
        return () => {
        }
    }, [permisionData])
    React.useEffect(() => {
        loadData()
        getcsmstright()
        return () => {
        }
    }, [])
    React.useEffect(() => {
        reloaddata()
        return () => {
        }
    }, [reloaddatas])
    React.useEffect(() => {
        loaddatabychoiceval()
        return () => {
        }
    }, [choiceval])

    const resData = (e) => {
        console.log(e);
    }
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const removeresData = async (e) => {
        // console.log(e)
        let element = []
        for (const iterator of e) {
            await element.push({ code: iterator.code.toString() })
        }
        setdataFordel(element)
        setTimeout(() => {
            deleteData(element)
        }, 300);
    };
    const deleteData = (element) => {
        if (element.length > 0) {
            setdescription("คุณต้องการลบข้อมูลที่เลือกไว้ใช่หรือไม่")
            setopenconfirmdialog(true)
        }
    }
    const resmainData = (e) => {
        console.log("resuserData", e);
        setmainData(e)

    };
    const checkData = (e) => {
        console.log("checkData", permisionData.length);
        if (permisionData.length > 0 && permisionData[0].code !== "") {
            setdisabledb_save(false)
        } else {
            setdisabledb_save(true)
        }
    };
    const loadData = async (e) => { //อ่านข้อมูลทั้งหมด 
        // await setRows([])
        setopenbackdrop(true)
        let url = "reportmanage/permision?top="
        // let url = "/permision?"
        // await axios.post(genpostURL(url), parameter).then(res => {
        await axios.get(genpostURL(url), options).then(res => {
            console.log("resdata loadData", res.data);
            if (res.data.length > 0) {
                setRowsall(res.data)
                // for (let index = 0; index < res.data.length; index++) {
                //     setRows((prevRows) => [...prevRows, { id: index, code: res.data[index].pid, nameth: res.data[index].nameTH, nameen: res.data[index].nameEN }])
                // }
            }
        }).finally(_ => {
            setopenbackdrop(false)
        })
    }
    const addReport = async (e) => {
        setopenFullScreenDialog(true)
    }
    const CloseDialog = async (e) => {
        //console.log("xxxxxxxxxxxxxxxxx", e);
        setopenFullScreenDialog(e)
        setreloaddatas(true)
    }
    // reload ข้อมูลหลังแก้ไข จะทำงานเมื่อ สเตรท reloaddatas เปลี่ยนค่า 
    const reloaddata = async () => {
        setreloaddatas(false)
        setopenbackdrop(true)
        let url = "reportmanage/permision?top="
        // let url = "/permision?"
        // await axios.post(genpostURL(url), parameter).then(res => {
        await axios.get(genpostURL(url), options).then(res => {
            console.log("resdata loadData", res.data);
            if (res.data.length > 0) {
                let item = []
                setRowsall(res.data)
                // for (let index = 0; index < res.data.length; index++) {
                //     item.push({ id: index, code: res.data[index].pid, nameth: res.data[index].nameTH, nameen: res.data[index].nameEN })
                // }
                // setRows(item)
            }
        }).finally(_ => {
            setopenbackdrop(false)
            loaddatabychoiceval()
        })
    }
    const rsConfirmdialog = (e) => {
        if (e === "Y") {
            deletepermissionindb()
        }
        else if (e === "N") {
            setreloaddatas(true)
        }
    }
    const deletepermissionindb = async (e) => {
        const parameterdel = new URLSearchParams();
        parameterdel.append("jwt", localStorage.getItem("Token"));
        parameterdel.append("permisionData", JSON.stringify(dataFordel));
        let url = `reportmanage/permisionremove?`
        // let url = `/permisionremove?`
        //   await axios.post(genpostURLTEST(url), parameterdel).then(res => {
        await axios.post(genURL(url), parameterdel).then(res => {
            console.log("deletepermissionindb", res.data.status);
            if (res.data.status === "success") {
                setMessagealert("ลบข้อมูลสำเร็จ")
                setColor("success")
                setOpensnackbar(true)
                setIcon(< CheckCircleOutlineRoundedIcon />)
                setTimeout(() => {
                    setreloaddatas(true)
                }, 500);
            }
        }).catch(error => {
            console.log("error" + error);
        });
    }
    //----------------------------------------------- ceta--------------------------------------------
    const onUseAutocompleteactivate = () => {
        console.log("onUseAutocompleteactivate");
    }
    const setvalue = async (e) => {
        console.log("setvalue", e[0].CODE);
        // elementparms.push({ inputname: inputid, val: e })
        await setChoiceval(e[0].CODE);
    }
    const getcsmstright = async () => {
        let url = "csmstright/GETALL?top=300"
        let elementcategory = []
        await axios.get(genURL(url)).then(res => {
            // await axios.post(genpostURLTEST(url), parameter).then(res => {
            console.log("resdata getcsmstright", res.data)
            // elementcategory = res.data
            // console.log("resdata", res.data);
            if (res.data.length > 0) {
                for (let index = 0; index < res.data.length; index++) {
                    elementcategory.push({ CODE: res.data[index].CODE, MYNAMETH: res.data[index].MYNAMETH + "(" + res.data[index].CODE + ")" })
                }
            }
        }).catch(error => {
            console.log("resdata getcsmstright", error);
            // this.setState({ opensnackbar: true })
            // this.setState({ color: "warning" })
            // this.setState({ icon: ErrorIcon })
            // this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
            // this.setState({ openBackdrop: false })
        });
        await console.log("elementcategory", elementcategory)
        await setChoiceData(elementcategory)
    }
    const loaddatabychoiceval = async () => {
        console.log("choiceval", choiceval);
        //  setopenbackdrop(true)
        let url = `reportmanage/reportpermision/usergroupcode/${choiceval}?`
        // let url = "/permision?"
        // await axios.post(genpostURL(url), parameter).then(res => {
        console.log("resdata loaddatabychoiceval", url);
        await axios.get(genpostURL(url), options).then(res => {
            console.log(" ss loaddatabychoiceval", res.data.length);
            if (res.data.length > 0) {
                let item = []
                for (let index = 0; index < res.data.length; index++) {
                    item.push({ id: index, code: res.data[index].pid, nameth: res.data[index].nameTH, nameen: res.data[index].nameEN })
                }
                setRows(item)
            } else {
                setRows([])
            }
        }).finally(_ => {
            //    setopenbackdrop(false)
        })
    }
    //---------------------------------------------end cate ---------------------------------------------------------
    const cutomButtons = <>
        <Button variant="outlined" startIcon={<GroupAddRoundedIcon />} size="small" onClick={e => addReport()}
            sx={styleMenu}>
            เพิ่มสิทธิ์รายงาน
        </Button>
    </>
    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <UseAutocomplete title={"กลุ่มสิทธิ์"}
                id={"permisioninput"}
                datalist={choiceData}
                valueReturn={e => setvalue(e)}
                activate={_ => onUseAutocompleteactivate()}
                placeholder={""}
                defaultvalue={choiceval}
            />
            < CustomDataGrid
                datacolumns={columns}
                datarows={rows}
                rowHeight={35}
                Dataintable={e => resData(e)}
                Dataintableremove={e => removeresData(e)}
                startRow={0}
                option={[{ add: false, del: true, select: false }]}
                checkboxSelection
                Dataselect={e => selcetRow(e)}
                //  RowsModelChange={_ => console.log("RowsModelChange")}
                customButton={cutomButtons}
            />
            <CustomSnackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setOpensnackbar(false) }}
                close />
            <CustomBackdrop open={openbackdrop} />
            {/* <Backdropprogress progressval={percentCompleted} open={openbackdrop} /> */}
            <FullScreenDialog open={openFullScreenDialog} title={titleFullScreenDialog} CloseDialog={e => CloseDialog(e)}>
                <Reportpremissionnanage CloseDialog={e => CloseDialog(e)} defaultpermisionData={rowsall} />
            </FullScreenDialog>
            <Confirmdialog Agreetxt={Agreetxt}
                description={description}
                open={openconfirmdialog}
                data={e => rsConfirmdialog(e)}
                closedialog={e => setopenconfirmdialog(false)} />
        </Box>
    );
}